export const NAME = 'dashboard-statistics';

export const toggleButtonGroupValues = {
	MY_TEAM: 'MY_TEAM',
	BRUTTO_PROD_TEAM_ACTIVITIES: 'BRUTTO_PROD_TEAM_ACTIVITIES',
};

export const quickFilter = {
	TODAY_MINUS_TWO_DAYS: 'TODAY_MINUS_TWO_DAYS',
	WEEK: 'WEEK',
	MONTH: 'MONTH',
};

export const bruttoTablePeriodQuickFilterSetup = [
	{
		label: 'dashboard:statistics.todayMinusTwoDays',
		value: quickFilter.TODAY_MINUS_TWO_DAYS,
	},
	{
		label: 'dashboard:statistics.week',
		value: quickFilter.WEEK,
	},
	{
		label: 'dashboard:statistics.month',
		value: quickFilter.MONTH,
	},
];

export const leadsOutOfMarketPlaceTypes = [
	'leadCountBirthday',
	'leadCountNameDay',
	'leadCountLifePolicyAnniversary',
	'leadCountClientAnniversary',
	'leadCountLeadFromWeb',
	'leadCountBusinessOpportunity',
	'leadCountLife',
	'leadCountPortfolioOpportunity',
	'leadCountAcquisitionsContacts',
	'leadCountSME',
];

export const leadsFromMarketPlaceTypes = [
	'leadCountInMarketplace',
	'leadCountLeadFromWebAssigned',
	'leadCountBusinessOpportunityAssigned',
	'leadCountLifeAssigned',
	'leadCountPortfolioOpportunityAssigned',
	'leadCountAcquisitionsContactsAssigned',
	'leadCountSMEAssigned',
];
